<template>
    <div id="app" ondragstart="return false">
        <router-view/>
        <!-- mask -->
        <video-mask></video-mask>
        <gallery-mask></gallery-mask>
    </div>
</template>

<script>
import VideoMask from "./components/Mask/VideoMask"
import GalleryMask from "./components/Mask/GalleryMask"
import Fingerprint2 from "fingerprintjs2"

export default {
    name: "app",
    components: {
        VideoMask,
        GalleryMask
    },
    data: () => ({
    }),
    created() {
        // 设置 Kakao key
        Kakao.init('f615344ec9ccea2cb3e4fc26423ce093')
    },
    mounted() {
        this.getFingerprint2()
    },
    methods: {
        getFingerprint2() {
            Fingerprint2.get({
                excludes: {
                    adBlock: true,
                    enumerateDevices: true,
                    availableScreenResolution: true,
                    userAgent: true,
                    platform: true,
                    hasLiedBrowser: true,
                    hasLiedOs: true,
                    plugins: true,
                    timezone: true,
                    timezoneOffset: true
                }
            }, (components) => {
                let murmur = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
                console.log(murmur)
                this.$store.commit("SET_Fingerprint", murmur)
            })
        }
    }
};
</script>

<style>
#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
}
</style>
